import '/vercel/path0/docs/demo/multiple-Portal.md?watch=parent';
export const toc = new Proxy([], {});
export const frontmatter = new Proxy({"title":"multiple-Portal","toc":"menu","filename":"docs/demo/multiple-Portal.md","lastUpdated":1780642515000,"nav":{"title":"Demo","path":"/demo"}}, {});

export const demoIndex = {
  ids: ["docs-demo-multiple-portal-demo-multiple-portal"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/demo/multiple-Portal.md?type=demo')
};